module.exports = __webpack_public_path__ + "img/kjicon1.2bf9b44f.svg";